// PublicCMILayout.js
import { Outlet, useLocation } from "react-router-dom";
import { Navigate, } from 'react-router-dom';
import { useAuthCuadroMando } from "./../context/AuthCuadroMandoContext"
import WelcomeSplash from "../../../component/WelcomeSplash/WelcomeSplash";

export function PublicCMILayout() {
    const { isAuthenticated, loading } = useAuthCuadroMando();
    const location = useLocation();

    if (isAuthenticated === null || loading) {
        return <WelcomeSplash isLoading={loading} />;
    }

    if (isAuthenticated === true) {
        const fromPath = location.state?.from;
        const redirectTo = fromPath || "/home";

        return <Navigate to={redirectTo} replace state={{ from: location }} />;
    } 
    
    return (
        <Outlet />
    );

}